import { Predicate } from "@siteimprove/alfa-predicate";
import { hasExplicitRole } from "./has-explicit-role.js";
import { hasImplicitRole } from "./has-implicit-role.js";
const { not, test } = Predicate;
/**
 * @public
 */
export function hasNonDefaultRole(element) {
    return test(hasExplicitRole((explicit) => test(not(hasImplicitRole((implicit) => implicit.equals(explicit))), element)), element);
}
//# sourceMappingURL=has-non-default-role.js.map